import { Directive, forwardRef, Input } from '@angular/core';
import { ObservableInput } from 'observable-input';
import { Observable } from 'rxjs';
import { FormStatus, FormStatusService } from './form-status.service';

@Directive({
  selector: '[formStatus]',
  providers: [
    {
      provide: FormStatusService,
      useExisting: forwardRef(() => FormStatusDirective),
    },
  ],
})
export class FormStatusDirective implements FormStatusService {
  @Input('formStatus')
  @ObservableInput()
  value: Observable<FormStatus>;
}
